import React, { Component, PropTypes } from 'react';
import ModalClose from 'components/ModalClose';

class AlertModal extends Component {
  constructor() {
    super();
    this.renderAlertContent = this.renderAlertContent.bind(this);
  }

  renderAlertContent() {
    const { alertMessage } = this.props;
    return (
      <div className='alert-content-wrapper'>
        <div className='icon-wrapper error'>
          <i className='material-icons md-20 error flex'>warning</i>
        </div>
        <p className='alert-body'>{alertMessage}</p>
      </div>
    );
  }

  render() {
    const { showAlert, onToggleAlertModal, onClose } = this.props;
    return (
      <div className='alert-modal error'>
        <ModalClose
          open={ showAlert }
          contentComponent={ showAlert ? this.renderAlertContent() : null }
          onCloseModal={ !onToggleAlertModal ? onClose : onToggleAlertModal }
          hideCloseButton={ true }
          singleColumn={ true }
        />
      </div>
    );
  }
}

AlertModal.propTypes = {
  showAlert: PropTypes.bool,
  onToggleAlertModal: PropTypes.func,
  alertMessage: PropTypes.string,
  onClose: PropTypes.func,
};

export default AlertModal;
